import { Parchment } from 'quill/core';

export default new Parchment.ClassAttributor('highlight', 'highlight', {
  scope: Parchment.Scope.INLINE,
  whitelist: ['blue', 'green', 'yellow', 'red'],
});
